import Logo from '@components/Logo.tsx';
import UserMenu from '@components/admin/header/UserMenu.tsx';
import GTranslate from '@components/web/translate/GTranslate.tsx';

const AdminHeader = () => {
  return (
    <div className="flex items-center justify-between w-full px-2 gap-5">
      <div>
        <Logo link="/admin" />
      </div>
      <div className="flex items-center gap-5">
        <GTranslate />
        <UserMenu />
      </div>
    </div>
  );
};

export default AdminHeader;
